<template>
  <div class="attr-score">
    <el-form :inline="true" :model="formInline">
      <div class="attr-score-form" v-for="(item, index) in formInline.eventGroupList" :key="index">
        <el-form-item class="attr-attr-identity" label="事件属性：" width="80px">
          <el-select v-model="item.attr_identity" placeholder="请选择" @change="handleEventChange($event, index)">
            <el-option v-for="attr in item.attrList" :key="attr.attr_identity" :label="attr.attr_name"
              :value="`${attr.attr_type}/${attr.attr_identity}`"></el-option>
          </el-select>
          <!-- 删除一组事件属性 -->
          <span class="delete-btn el-icon-close" @click="handleReduceGroupRules(index)"
            v-if="formInline.eventGroupList.length !== 1"></span>
        </el-form-item>
        <el-form-item label="评分规则：" class="comment-box" v-if="item.attr_identity != ''">
          <div class="comment-rule" v-for="(one, k) in item.scoreRules" :key="k">
            <el-select v-model="one.relation" placeholder="请选择" class="attr-score-input">
              <el-option v-for="(rela, i) in item.relationList" :key="i" :label="rela.label" :value="rela.value">
              </el-option>
            </el-select>
            <el-input placeholder="请输入内容"
              v-if="item.inputType === 'dictionary' && one.relation != 'empty' && one.relation != 'not_empty'"
              class="attr-score-input" v-model="one.input"></el-input>
            <!-- <el-select v-if="item.inputType === 'dictionary'" class="attr-score-input" v-model="item.input"
              placeholder="请选择" @focus="dictionarys">
              <el-option v-for="item in dictionaryList" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select> -->
            <el-input placeholder="请输入内容"
              v-if="item.inputType === 'txt' && one.relation != 'empty' && one.relation != 'not_empty'"
              class="attr-score-input" v-model="one.input">
            </el-input>
            <!-- 非区间值 -->
            <el-input placeholder="请输入数量" type="number"
              v-if="item.inputType === 'number' && one.relation != 'empty' && one.relation != 'not_empty' && one.relation != 'gtele'"
              class="attr-score-input" v-model="one.input"></el-input>
            <!-- 区间值 -->
            <div class="gteleInput"
              v-if="item.inputType === 'number' && one.relation != 'empty' && one.relation != 'not_empty' && one.relation == 'gtele'">
              <el-input placeholder="请输入数量" type="number" class="attr-score-input" v-model="one.input1"></el-input>-
              <el-input placeholder="请输入数量" type="number" class="attr-score-input" v-model="one.input2"></el-input>
            </div>
            <el-input placeholder="请输入金额" type="number"
              v-if="item.inputType === 'money' && one.relation != 'empty' && one.relation != 'not_empty'  && one.relation != 'gtele'"
              class="attr-score-input" v-model="one.input"></el-input>
            <!-- 区间值 -->
            <div class="gteleInput"
              v-if="item.inputType === 'money' && one.relation != 'empty' && one.relation != 'not_empty' && one.relation == 'gtele'">
              <el-input placeholder="请输入数量" type="number" class="attr-score-input" v-model="one.input1"></el-input>-
              <el-input placeholder="请输入数量" type="number" class="attr-score-input" v-model="one.input2"></el-input>
            </div>
            <el-cascader v-if="item.inputType === 'location' && one.relation != 'empty' && one.relation != 'not_empty'"
              :options="regionData" v-model="one.region">
            </el-cascader>
            <el-switch v-model="one.switch" active-color="#13ce66" inactive-color="#C8C8C8">
            </el-switch>
            <span class="switchBtn">{{ one.switch ? '加' : '减' }}</span>
            <el-input class="attr-score-input" type="number" v-model="one.score"></el-input>
            <span class="scoreTxt">分</span>
            <!-- 删除一组规则 -->
            <span class="delete-btn el-icon-close" @click="handleReduceRules(k, index)"></span>
          </div>
          <div class="add-rule" v-if="item.attr_identity != '' && item.scoreRules.length < 8"
            @click="handleAddRules(index)">
            <span class="el-icon-circle-plus-outline"></span>
            新增规则
          </div>
        </el-form-item>
      </div>
      <div class=" add-group-rule" v-if="formInline.eventGroupList.length < 8 " @click="handleAddGroupRules()">
        <span class="el-icon-circle-plus-outline"></span>
        新增一组属性规则
      </div>
    </el-form>

    <div class="btns">
      <el-button class="dialog-cancel-btn" style="margin-right: 20px" @click="beforeAttrEdit">上一步</el-button>
      <el-button class="dialog-confirm-btn" style="margin-right: 32px" type="primary" @click="editPassValue">确 定
      </el-button>
    </div>
  </div>
</template>
<script>
import { RELATIONSHIP_OBJ } from '../constant'
import {
  regionData,
  regionDataPlus,
  CodeToText
} from 'element-china-area-data'
import { getAudHigSearDicList } from '@/api/set.js'
export default {
  props: {
    attrList: {
      type: Array,
      default () {
        return []
      }
    },
    createFormIdentity: {
      type: String,
      default () {
        return ''
      }
    },
    markAttr: {
      type: Object,
      default () {
        return []
      }
    }
  },
  watch: {
    attrList: {
      handler (val) {
        this.handleAttrListChange(val)
      },
      deep: true,
      immediate: true
    },
    createFormIdentity: {
      handler (val) {
        return val
      },
      deep: true,
      immediate: true
    },
    markAttr: {
      handler (val) {
        return val
      },
      deep: true,
      immediate: true
    }
  },
  data () {
    return {
      formInline: {
        eventGroupList: []
      },
      typeObj: {},
      regionData: regionData,
      attrLists: [],
      options: [
        {
          value: 'ziyuan',
          label: '资源',
          children: [
            {
              value: 'axure',
              label: 'Axure Components'
            },
            {
              value: 'sketch',
              label: 'Sketch Templates'
            },
            {
              value: 'jiaohu',
              label: '组件交互文档'
            }
          ]
        }
      ],
      eventIdentity: '',
      dictionaryList: [],
      mark: [],
      region: []
    }
  },
  mounted () { },
  methods: {
    // 新增规则
    handleAddRules (index) {
      for (let i = 0; i < this.formInline.eventGroupList.length; i++) {
        if (index == i) {
          this.formInline.eventGroupList[i].scoreRules.push({
            relation: '',
            input: '',
            input1: '',
            input2: '',
            region: [], //地理位置
            switch: true // true代表加  false代表减
          })
        }
      }
    },
    // 删除一组规则
    handleReduceRules (k, index) {
      this.formInline.eventGroupList[index].scoreRules.splice(k, 1)
    },
    // 添加一组属性规则
    handleAddGroupRules () {
      let index = this.formInline.eventGroupList.length
      this.formInline.eventGroupList.push({
        attrList: this.attrLists,
        attr_identity: '',
        index: index,
        relationList: [],
        scoreRules: [
          {
            relation: '',
            input: '',
            input1: '',
            input2: '',
            region: [], //地理位置
            score: '',
            switch: true // true代表加  false代表减
          }
        ],
        inputType: ''
      })
    },
    // 删除一组属性规则
    handleReduceGroupRules (index) {
      this.formInline.eventGroupList.splice(index, 1)
    },
    // 切换事件属性
    handleEventChange (event, index) {
      this.eventIdentity = event
      for (let item of this.formInline.eventGroupList[index].scoreRules) {
        item.relation = ''
        item.input = ''
        item.region = []
        item.switch = true
        item.score = ''
        item.input1 = ''
        item.input2 = ''
      }
      const typeList = event.split('/')
      // 字典、文本 数字、金额 地址 类型
      const type = typeList[0]
      // 将类型存起来，以它目前所在的属性规则索引为key存(方便区分是在哪个属性索引下)
      this.typeObj[index] = type
      // 给评分规则关系的下拉根据不同的type（字典、文本 数字、金额 地址）赋不同的关系
      this.formInline.eventGroupList[index].relationList =
        RELATIONSHIP_OBJ[type]
      // 控制评分规则中不同输入框类型
      this.formInline.eventGroupList[index].inputType = type
    },
    handleAttrListChange (val) {
      this.attrLists = val
      let mark = JSON.parse(this.markAttr.markAttr)
      this.formInline.eventGroupList = []
      let attrList = []
      let ruleList = {}
      // 处理返回的结果
      console.log(mark)
      if (mark != null) {
        mark.forEach((item, index) => {
          attrList.push({
            attrList: val,
            attr_identity: `${item.attr.attr_type}/${item.attr.attr_identity}`,
            index: item,
            relationList: RELATIONSHIP_OBJ[item.attr.attr_type],
            inputType: item.attr.attr_type,
          })
          ruleList[index] = item.ruleList.map(ele => {
            return {
              relation: ele.operatorType, //评分规则下的活动区域
              input: ele.value,
              input1: '',
              input2: '',
              region: [], //地理位置
              switch: ele.symbol == 'ADD' ? true : false, // true代表加  false代表减
              score: ele.score
            }
          })
          attrList[index].scoreRules = ruleList
        })
        attrList.forEach((item, index) => {
          item['scoreRules'] = ruleList[index]
        })

        this.formInline.eventGroupList = attrList
        console.log(this.formInline.eventGroupList, 'this.formInline.eventGroupList')
        this.formInline.eventGroupList.forEach((item, index) => {
          item.scoreRules.forEach(i => {
            // 处理地理位置
            if (item.inputType == 'location') {
              let regions = []
              for (let its of i.input.split(',')) {
                let province = its.substring(0, 3) + '000'
                let city = its.substring(0, 4) + '00'
                let district = its
                i.region.push(province, city, district)
              }
            }
            // 区间值
            if (i.relation == 'gtele') {
              i.input1 = i.input.split('-')[0]
              i.input2 = i.input.split('-')[1]
            }
          })
        })
      } else {
        this.formInline = {
          eventGroupList: [
            {
              attrList: val,
              attr_identity: '',
              index: 0,
              relationList: [],
              scoreRules: [
                {
                  relation: '',
                  input: '',
                  score: '',
                  input1: '',
                  input2: '',
                  switch: true // true代表加  false代表减
                }
              ],
              inputType: ''
            }
          ]
        }
      }
      console.log(this.formInline)
    },
    // 受众来源列表（字典类型数据）
    // dictionarys () {
    //   let data = {
    //     eventIdentity: this.eventIdentity.split('/'),
    //     attrIdentity: this.createFormIdentity,
    //     name: ''
    //   }
    //   getAudHigSearDicList().then(res => {
    //     if (res.data.code == 200) {
    //       console.log(res)
    //       this.dictionaryList = res.data.result
    //     }
    //   })
    // },
    beforeAttrEdit () {
      this.$emit('beforeAttrEdit', false)
    },
    editPassValue () {

      this.formInline.eventGroupList.forEach(item => {
        item.scoreRules.forEach(ele => {
          // 处理区间值
          if (ele.relation == 'gtele') {
            ele.input = ele.input1 + '-' + ele.input2
          }
          // 处理地理位置
          if (item.inputType == 'location') {
            if (ele.relation != 'empty' && ele.relation != 'not_empty') {
              ele.input = ele.region[ele.region.length - 1]
            } else {
              ele.input = ''
            }
          }
        })
      })
      console.log(this.formInline)
      this.$emit('editPassValue', this.formInline)
    }
  }
}
</script>

<style scoped>
.attr-score {
  height: 450px;
  /* overflow-y: auto;
  overflow-x: hidden; */
}
.attr-score .el-form {
  height: 382px;
  overflow: hidden auto;
}
.attr-score-form {
  background-color: #f8f8f8;
  padding: 15px 20px;
  margin-top: 15px;
  box-sizing: border-box;
}
.attr-score .add-rule {
  width: 100px;
  margin: 20px auto 0 auto;
  color: #1980ff;
  cursor: pointer;
}
.add-group-rule {
  width: 200px;
  margin: 10px auto;
  color: #1980ff;
  cursor: pointer;
  text-align: center;
}
.attr-score .add-rule span,
.delete-btn {
  /* display: inline-block;
  width: 16px;
  height: 16px;
  border: 1px solid #1980ff;
  text-align: center;
  line-height: 16px;
  border-radius: 50%; */
  cursor: pointer;
  margin-left: 10px;
}
.attr-score .add-rule span {
  color: #1980ff;
}
</style>
